import {
    BodyWrapper,
    LineWrapper,
} from "./styles/AboutModal.styles";
import { useEffect, useState } from "react";

import Build from "app/build";
import { Container } from "react-bootstrap";
import LoadingIcon from "shared/components/feedback/loading/LoadingIcon";
import Text from "shared/components/data-display/mui/Text";
import { useApi } from "shared/services/api/useApi";

const AboutModal = () => {
    const { getDataAsync } = useApi();
    const [aclVersion, setACLVersion] = useState("");
    const [allocationVersion, setAllocationVersion] = useState("");
    const [coreVersion, setCoreVersion] = useState("");
    const [membershipVersion, setMembershipVersion] = useState("");
    const [frontendVersion, setFrontendVersion] = useState("");

    useEffect(() => {
        const getVersion = async (name) => {
            const payload = await getDataAsync(name);
            return payload.json();
        };

        const loadVersions = async () => {
            try {
                const feVersion = await Build.get();
                if (feVersion) {
                    setFrontendVersion(`${feVersion.version} - ${feVersion.date}`);
                } else {
                    setFrontendVersion(`Can't get frontend version`);
                }
            } catch {
                setFrontendVersion(`Can't get frontend version`);
            }

            try {
                const mv = await getVersion("membershipMSVersion");
                if (mv) {
                    setMembershipVersion(`${mv.version} - ${mv.date}`);
                } else {
                    setMembershipVersion(`Can't get membership service version`);
                }
            } catch {
                setMembershipVersion(`Can't get membership service version`);
            }

            try {
                const cv = await getVersion("coreMSVersion");
                if (cv) {
                    setCoreVersion(`${cv.Version} - ${cv.Date}`);
                } else {
                    setCoreVersion(`Can't get core service version`);
                }
            } catch {
                setCoreVersion(`Can't get core service version`);
            }

            try {
                const av = await getVersion("allocationMSVersion");
                if (av) {
                    setAllocationVersion(`${av.version} - ${av.date}`);
                } else {
                    setAllocationVersion(`Can't get allocation service version`);
                }
            } catch {
                setAllocationVersion(`Can't get allocation service version`);
            }

            try {
                const aclv = await getVersion("aclMSVersion");
                if (aclv) {
                    setACLVersion(`${aclv.Version} - ${aclv.Date}`);
                } else {
                    setACLVersion(`Can't get ACL service version`);
                }
            } catch {
                setACLVersion(`Can't get ACL service version`);
            }
        };

        loadVersions();
    }, [getDataAsync]);

    const fontVariant = "small";
    const fontVersionVariant = "smallBold";
    const titleStyle = {
        color: globalThis.config.colors.gray3,
    };

    return (
        <Container fluid>
            <BodyWrapper>
                <LineWrapper>
                    <Text variant={fontVariant} style={titleStyle}>
                        Frontend - {"Abril 2026"}
                    </Text>
                    <Text variant={fontVersionVariant}>
                        {frontendVersion === "" ? (
                            <LoadingIcon />
                        ) : (
                            frontendVersion
                        )}
                    </Text>
                </LineWrapper>
                <LineWrapper>
                    <Text variant={fontVariant} style={titleStyle}>
                        Backend Membership
                    </Text>
                    <Text variant={fontVersionVariant}>
                        {membershipVersion === "" ? (
                            <LoadingIcon />
                        ) : (
                            membershipVersion
                        )}
                    </Text>
                </LineWrapper>
                <LineWrapper>
                    <Text variant={fontVariant} style={titleStyle}>
                        Backend Allocation
                    </Text>
                    <Text variant={fontVersionVariant}>
                        {allocationVersion === "" ? (
                            <LoadingIcon />
                        ) : (
                            allocationVersion
                        )}
                    </Text>
                </LineWrapper>
                <LineWrapper>
                    <Text variant={fontVariant} style={titleStyle}>
                        Backend Core
                    </Text>
                    <Text variant={fontVersionVariant}>
                        {coreVersion === "" ? (
                            <LoadingIcon />
                        ) : (
                            coreVersion
                        )}
                    </Text>
                </LineWrapper>
                <LineWrapper>
                    <Text variant={fontVariant} style={titleStyle}>
                        Backend ACL
                    </Text>
                    <Text variant={fontVersionVariant}>
                        {aclVersion === "" ? (
                            <LoadingIcon />
                        ) : (
                            aclVersion
                        )}
                    </Text>
                </LineWrapper>
            </BodyWrapper>
        </Container>
    );
};

export default AboutModal;
